var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { flowsApi } from 'apis/flows';
import { analytics } from 'app/utils/segment';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
export const DeleteModal = ({ schedule: { id, name }, onClose, refetchItems, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteSchedule] = flowsApi.useDeleteFlowScheduleMutation();
    const notify = useNotifications();
    const handleDelete = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        analytics.businessHoursDeleteScheduleFormSubmitted();
        setIsLoading(true);
        const res = yield deleteSchedule({ id });
        if ('data' in res) {
            notify({
                title: `Schedule deleted!`,
                time: 5000,
            }, NotificationType.Success);
            refetchItems();
            onClose();
        }
        else {
            setIsLoading(false);
            notify({
                title: `An error occurred when trying to delete "${name}" schedule.`,
            }, NotificationType.Error);
        }
    }), [deleteSchedule, id, name, notify, refetchItems, onClose]);
    return (_jsx(ConfirmModal, { isShown: true, cancel: () => {
            onClose();
            analytics.businessHoursDeleteScheduleFormCancelled();
        }, confirm: handleDelete, confirmProps: { isLoading }, confirmText: "Delete", headline: "Delete schedule?", text: `Are you sure you want to delete the schedule "${name}"? Please note that this action can't be undone.` }));
};
